import * as actiontypes from '@/store/types';
import { defineStore } from 'pinia';
export const useFinancingPageDetailsStore = defineStore('financingPageDetails', {
  state() {
    return {
      eventDrivenSessionCount: 0,
    };
  },
  actions: {
    [actiontypes.SET_EVENT_DRIVEN_SESSION_COUNT](payload) {
      this.eventDrivenSessionCount = payload;
    },
  },
});
